---
en:
  notification_system:
    instant_sender:
      associated_event: Associated Event
      capacity_used: Capacity Used
      current_deviation: Current Deviation
      current_energy: Current Energy
      deviation_value: "%{deviation}%"
      energy_mwh: "%{energy} MWh"
      event_component: Component
      event_started: Started
      event_status: Status
      maximum_capacity: Maximum Capacity
      optimization_initiated: The production optimization has been initiated and market submission will follow.
      percentage: "%{percentage}%"
      reservoir_energy_status: Reservoir Energy Status
      threshold_setting: Threshold Setting
      threshold_value: "±%{threshold}%"
      toast_title: InstantSender trigger at %{power_plant_name}
      trigger_time: Trigger Time
      trigger_type: Trigger Type
      trigger_types:
        manual: Manual Trigger
        other: Other
        water_level_high: Water Level High
        water_level_low: Water Level Low
      triggered_for: InstantSender has been triggered for %{power_plant_name}
      view_details: View details in the Portal production simulation plan.
      water_level: Water Level
      water_level_masl: "%{level} MASL"
